import { render, staticRenderFns } from "./FormPicBranch.vue?vue&type=template&id=2247e2b0&scoped=true"
import script from "./FormPicBranch.vue?vue&type=script&lang=js"
export * from "./FormPicBranch.vue?vue&type=script&lang=js"
import style0 from "./FormPicBranch.vue?vue&type=style&index=0&id=2247e2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247e2b0",
  null
  
)

export default component.exports